/**
 * App Component
 *
 * Root component of the application.
 * Wraps the app with all necessary providers.
 */

import { ErrorBoundary } from '@presentation/components/common';
import AppRoutes from '@presentation/router/AppRouter';
import { AuthProvider } from './presentation';

export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ErrorBoundary>
  );
}
